module.exports = __webpack_public_path__ + "img/bk1Mobile.4c5d0cab.jpg";